<div class="pme-container">
    <div class="pme-new-row">
        <!-- Carrinho de Compras -->
        <div class="cart" *ngIf="this.context !== 'RETENTION'">
            <!-- Exemplo de visualização do produto selecionado -->
            <!-- <div *ngIf="this.cartComponent && this.cartComponent.cart">
                <pme-product-choice [cardTitle]="this.cardTitle" [changeText]="this.changeProductText" [changeLink]="this.changeProductLink" [productName]='this.cartComponent.cart.product.name' [totalValue]="this.cartComponent.cart.baseValue.toString()" [description]="this.cartComponent.cart.product.description"
                    [extraBalanceCoupon]="this.cartComponent.cart.extraBalanceCoupon">
                </pme-product-choice>
            </div>
            <div class="pme-aside-warning display-utils-row display-utils-between-center display-utils-gap-16" *ngIf="this.classificationIdentifier && this.classificationIdentifier === 'consulta-e-recuperacao-de-dividas'">
                <div>
                    <p *ngIf="this.cartComponent && this.cartComponent.cart && this.cartComponent.cart.extraBalanceCoupon ; else noExtraBalance">Créditos do pacote expiram em 6 meses. Créditos do bônus válidos até {{this.cartComponent.cart.extraBalanceCoupon.formatedExpirationDate}}.</p>
                    <ng-template #noExtraBalance>
                        <p>Créditos do pacote expiram em 6 meses.</p>
                    </ng-template>
                </div>
            </div> -->
            <pme-cart (allowAutomaticRechargeChange)="this.onAutomaticRechargeChange($event)" (cartUpdated)="this.handleCartUpdate()" [newPayment]="true" [paymentFormSubmitting]="submitting" [installmentSelected]="this.selectedOptionInstallmentMSG" ></pme-cart>
        </div>

        <div class="payment-method">
            <main>
                <!-- Adicionar/Editar Forma de Pagamento -->
                <h1 *ngIf="this.context !== 'RETENTION' && this.cart && !this.cart.allowSaleWithoutPayment"
                    class="mat-headline">Informações de pagamento</h1>
                <!-- End - Adicionar/Editar Forma de Pagamento -->

                <!-- Escolher Forma de Pagamento  -->
                <pme-hero type="warning" title="Não foi possível efetuar o seu pagamento!"
                    *ngIf="this.context === 'RETENTION'">
                    <p *ngIf="this.retentionCount === 1">Não fique sem cuidar da sua empresa, contrate o plano por um
                        período menor no cartão de crédito ou gere um boleto bancário</p>
                    <p *ngIf="this.retentionCount >= 2">Não fique sem cuidar da sua empresa, aproveite o desconto no
                        boleto bancário para ter acesso a todos os benefícios do nosso monitoramento</p>
                </pme-hero>
                <!-- End - Escolher Forma de Pagamento  -->
                <pme-hero type="{{this.heroData.type}}" title="{{this.heroData.title}}" *ngIf="this.showHero"
                    showButton="{{this.heroData.showButton}}" buttonName="{{this.heroData.buttonName}}"
                    redirectURL="{{this.heroData.redirectURL}}">
                    <p *ngFor="let content of this.heroData.contents" [innerHTML]="content"></p>
                </pme-hero>
                <pme-payment-form
                    *ngIf="(this.cart || (this.context === 'RETENTION' && this.paymentOptions && this.paymentOptions.length))"
                    [paymentOptions]="this.paymentOptions" [termOfUse]="this.termOfUseUrl"
                    [discountBadge]="this.discountBadge" [retentionBankBilletCart]="this.originalCart"
                    [retentionCreditCardCart]="this.retentionCart"
                    [automaticRechargeOnly]="this.cart.product.automaticRechargeOnly"
                    [hasInstallment]="this.cart.product.hasInstallment" [creditCardData]="this.creditCardData"
                    [creditCardsData]="this.creditCardsData" [maxLimitCreditCards]="maxLimitCreditCards"
                    [campaignMessage]="this.cart && this.cart.allowSaleWithoutPayment ? this.cart.saleMessageInfo : null"
                    [context]="this.context" (paymentConditionSelected)="onPaymentConditionSelected($event)"
                    (formSubmitted)="onPaymentFormSubmitted($event)"
                    (paymentMethodSelected)="onPaymentMethodSelected($event)"
                    (deleteCreditCard)="handleDeleteCreditCard($event)" 
                    [allowAutomaticRecharge]="this.customer.provisioningParameter.allowAutomaticRecharge" 
                    [newPayment]="true"
                    [hiddenAdobeDtm]="this.hiddenAdobeDtm"
                    [suggestionMessage] = "this.suggestionMessage"
                    [isACreditCardError]="this.isACreditCardError" 
                    [adyenCardError] = "this.adyenCardError"
                    (selectedOptionInstallmentEmitter) = "this.recieveSelectedOptionMSG($event)"
                    >
                </pme-payment-form>
            </main>
        </div>
    </div>
</div>